import { useDispatch, useSelector } from 'react-redux';
import { brandActions } from '../../../store/modules/brand';
import { useEffect } from 'react';
import {
  BRAND_DETAIL_NOTICE_PRODUCT_FILTER_OPTION_MODEL,
  BRAND_DETAIL_NOTICE_PRODUCT_SORT_OPTION_MODEL,
} from '../../../store/modules/brand/models';
import { LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';

export const useBrandDetailNoticeProduct = (storeId) => {
  const dispatch = useDispatch();

  // redux store에서 브랜드 공지사항 정보 조회
  const selectBrandNoticeProduct = (state) => state.brand.brandDetail.noticeProduct;
  const brandDetailNoticeProductInfo = useSelector(selectBrandNoticeProduct);
  const { listInfo, summary } = brandDetailNoticeProductInfo;

  // 마운트시에 기본옵션 적용하여 브랜드 공지사항 정보 불러오기
  useEffect(() => {
    dispatch(
      brandActions.getBrandDetailNoticeProduct({
        storeId,
        filterOption: BRAND_DETAIL_NOTICE_PRODUCT_FILTER_OPTION_MODEL,
        /**
         *  검색 옵션
         */
        sortOption: BRAND_DETAIL_NOTICE_PRODUCT_SORT_OPTION_MODEL,
        /**
         *  리스트 pagination
         */
        pagination: LIST_PAGINATION_MODEL,
      }),
    );
  }, [storeId, dispatch]);

  /**
   * @name getBrandDetailNoticeProduct
   * @description [브랜드 상세] 적용한 옵션으로 공지사항 정보 가져오기
   * @param {object} data
   *
   * @returns void
   * */
  const getBrandDetailNoticeProduct = (data) => {
    const { filterOption, sortOption, pagination } = listInfo;

    dispatch(
      brandActions.getBrandDetailNoticeProduct({
        storeId,
        filterOption,
        sortOption,
        pagination,
        ...data,
      }),
    );
  };

  /**
   * @name getBrandDetailNoticeExcelDownload
   * @description [브랜드 상세] 적용한 옵션으로 공지사항 엑셀 저장
   *
   * @returns void
   * */
  const getBrandDetailNoticeExcelDownload = () => {
    const { filterOption, sortOption } = listInfo;

    dispatch(
      brandActions.getBrandDetailNoticeExcelDownload({
        storeId,
        filterOption,
        sortOption,
      }),
    );
  };

  return { listInfo, summary, getBrandDetailNoticeProduct, getBrandDetailNoticeExcelDownload };
};
